import type { ProjectModel } from '@ve-pro/api/project/type'

export function resolveVeId(id: ProjectModel['id']): string {
  return `ve_${id}`
}
export function resolveReplaceId(id: ProjectModel['id']): string {
  return `replace_${id}`
}

// 打开视频编辑器的方法
export function openVe(id: ProjectModel['id'], replace = false): void {
  const url = `${process.env.VEPRO}?id=${id}`
  if (!replace) {
    // 注意：固定的写法，若需要调整，需要同步视频编辑器那边的代码！！！
    const _id = resolveVeId(id)
    window.open(url, _id)
  } else {
    window.location.replace(url)
  }
}

// 打开替换视频的方法
export function openVeReplace(id: ProjectModel['id'], replace = false): void {
  const url = `${process.env.VEPRO_REPLACE}?template_id=${id}`
  if (!replace) {
    const _id = resolveVeId(id)
    window.open(url, _id)
  } else {
    window.location.replace(url)
  }
}
